import { styled as e, css as t } from "styled-components";
import { MediaQuery as a } from "../../../../../styles/variables.js";
import { CaptionHeavy as n } from "../../../../../styles/typography/index.js";
import { Colors as r } from "../../../../../styles/colors/index.js";
import { DealVoteButton as l } from "../../../DealVoteButton/index.js";
import { Button as p } from "../../../../../components/Button/index.js";
import { Theme as i } from "../../../../../styles/themes/index.js";
import { DealShareButtonDropdown as s } from "../../../DealShareButton/dropdown.js";
const h = e.div`
  display: flex;

  justify-content: ${({ $hasAnimation: o }) => o ? "end" : "space-between"};
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`, d = t`
  position: absolute;
  left: 12px;

  @media ${a.SCREEN_MD_UP} {
    left: 178px;
  }
`, u = e.div`
  display: flex;
  margin-right: 12px;

  ${({ $hasAnimation: o }) => o && d}
`, S = e(l)`
  padding: 4px 8px;
  border-radius: 24px;
  margin-right: 12px;
  max-height: 32px;

  > span {
    ${n}
  }

  ${({ $keepMobileLayout: o }) => !o && t`
      @media ${a.SCREEN_MD_UP} {
        padding: 8px 12px;
      }
    `}
`, C = e(p)`
  ${n}
  display: flex;
  align-items: center;
  max-height: 32px;
  min-height: 32px;
  padding: 4px 12px 4px 8px;
  border-radius: 24px;
  transition: all 0.5s ease;

  &:hover:not(:disabled) {
    background-color: rgb(${i.colors.Kilo});
  }

  ${({ inactive: o }) => o && t`
      color: rgb(${r.Gray});
    `}

  i {
    font-size: 24px;
    margin-right: 4px;
    color: rgb(${i.colors.Alpha});

    ${({ inactive: o }) => o && t`
        color: rgb(${r.Gray});
      `}
  }

  &[data-keep-mobile-layout='false'] {
    @media ${a.SCREEN_MD_UP} {
      padding: 4px 16px 4px 12px;
    }
  }
`, D = e(s)`
  margin-left: 12px;
`, E = e(p)`
  &&& {
    ${n}
    display: flex;
    align-items: center;
    min-height: 32px;
    border-radius: 24px;
    padding: 4px 8px 4px 16px;
    white-space: nowrap;
    transition: all 0.5s ease;

    &:hover:not(:disabled) {
      color: rgb(${({ isFixedCard: o }) => !o && i.colors.Alpha});
      background: rgb(
        ${({ isFixedCard: o }) => !o && i.colors.Kilo}
      );
    }

    ${({ inactive: o }) => o && t`
        color: rgb(${r.Gray});
      `}

    i {
      font-size: 24px;
      color: rgb(${({ isFixedCard: o }) => !o && i.colors.Brand});

      ${({ inactive: o }) => o && t`
          color: rgb(${r.Gray});
        `}
    }

    &[data-keep-mobile-layout='false'] {
      @media ${a.SCREEN_MD_UP} {
        padding: 4px 16px 4px 24px;
      }
    }
  }
`, _ = e.span`
  display: inherit;

  &[data-keep-mobile-layout='false'] {
    @media ${a.SCREEN_MD_UP} {
      display: none;
    }
  }
`, B = e.span`
  display: none;

  &[data-keep-mobile-layout='false'] {
    @media ${a.SCREEN_MD_UP} {
      display: flex;
    }
  }
`;
export {
  C as CommentButton,
  h as Container,
  u as LeftActionsContainer,
  B as SeeDealBigScreenText,
  E as SeeDealButton,
  _ as SeeDealMobileText,
  D as ShareButton,
  S as VoteButton
};
